const storeRouters = [
  {
    path: '/store/create',
    name: '',
    component: () => import(/* webpackChunkName: "store" */ '@/views/store/create'),
    meta: { title: '店铺录入', keepAlive: false }
  },
  {
    path: '/store/receiveList',
    name: '',
    component: () => import(/* webpackChunkName: "store" */ '@/views/store/receiveList'),
    meta: { title: '店铺认领入驻', keepAlive: false }
  },
  {
    path: '/store/receive',
    name: '',
    component: () => import(/* webpackChunkName: "store" */ '@/views/store/receive'),
    meta: { title: '店铺认领入驻', keepAlive: false }
  },
  {
    path: '/store/enroll',
    name: '',
    component: () => import(/* webpackChunkName: "store" */ '@/views/store/enroll'),
    meta: { title: '选手报名' }
  },
  {
    path: '/store/agreement',
    name: 'store_agreement',
    component: () => import(/* webpackChunkName: "store" */ '@/views/store/agreement'),
    meta: { title: '入驻协议', keepAlive: false }
  }
]

export default storeRouters
